module.exports = __webpack_public_path__ + "static/sidemail-api-docs-759c4537d28c7223bed0b120e2c5f5a3.png";